import { useNavigate } from "react-router-dom";
import React, { useState } from "react";

import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { Button } from "@mui/material";
import Stack from "@mui/material/Stack";

import Search from "../../Search/Search";
import Title from "../../../common/Title";
import BatchList from "../../../common/BatchList";

import useBatchListState from "../../../../hooks/useBatchListState";
import { __getResetBatches } from "../../../../api/sim";
import { CLIENTS, OPERATIONS } from "../../../../constants/value";

const ClearStatusBatchList = () => {
  const nav = useNavigate();
  const [searchActive, setSearchActive] = useState(false);

  const {
    data,
    loading,
    metaData,
    response,
    statusCategories,
    handlePageChange,
    handlePageSizeChange,
    handleStatusCategoryChange,
  } = useBatchListState(__getResetBatches, { client: CLIENTS.tmobilej });

  return (
    <Box sx={{ width: "100%" }}>
      <Title variant="h5" content="Clear Status" gutterBottom />
      <Search
        key="tmobilej-clear-status"
        client={CLIENTS.tmobilej}
        operation={OPERATIONS.clear_status}
        searchActive={searchActive}
        setSearchActive={setSearchActive}
      />
      {!searchActive &&
        (response ? (
          <>
            <Grid container justifyContent="flex-start" spacing={2}>
              <Grid item>
                <Stack spacing={2} direction="row">
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => nav("form")}
                  >
                    Submit new ICCIDs
                  </Button>
                </Stack>
              </Grid>
            </Grid>
            <BatchList
              data={data}
              loading={loading}
              meta={metaData}
              changeNumber={true}
              statusCategories={statusCategories}
              onStatusCategoryChange={handleStatusCategoryChange}
              handlePageChange={handlePageChange}
              handlePageSizeChange={handlePageSizeChange}
            />
          </>
        ) : (
          <Title content="Please wait..." variant="subtitle2" gutterBottom />
        ))}
    </Box>
  );
};

export default ClearStatusBatchList;
